import React from 'react';

function ErrorDisplay({ error, className = '' }) {
  if (!error) return null;

  return (
    <div className={`error-display ${className}`}>
      <p className="error-message">{error}</p>
    </div>
  );
}

export default ErrorDisplay;
